import { hostSummaryReactions } from '@/utils/reactions';
import { motion } from 'motion/react';
import { useEffect, useState } from 'react';
import * as queries from '@/graphql/queries';
import { useAmplifyApiClient } from '@/hooks/AmplifyApiClientHooks';
import { useSessionId } from '@/hooks/HostSessionControlHooks';

const ArtworkReactionsSummary = () => {
  const client = useAmplifyApiClient();
  const sessionId = useSessionId();
  const [artworkReactionsSummary, setArtworkReactionsSummary] = useState<
    { reactionValue: number; counter: number }[]
  >([]);

  useEffect(() => {
    if (!sessionId) return;

    const fetchCounts = async () => {
      try {
        const result = (await client.graphql({
          query: queries.artworkReactionCountBySession,
          variables: { sessionId }
        })) as any;

        const counts: Array<{ reactionType: number; count: number }> =
          result.data?.artworkReactionCountBySession ?? [];

        const summary = hostSummaryReactions.map((item) => {
          const entry = counts.find((c) => c.reactionType === item.reactionValue);
          return { reactionValue: item.reactionValue, counter: entry?.count ?? 0 };
        });

        setArtworkReactionsSummary(summary);
      } catch (e) {
        console.error('Error fetching reaction counts', e);
      }
    };

    fetchCounts();
  }, [client, sessionId]);

  const isMostShared = (reactionValue: number) => {
    let maxReactionValues: number[] = [];
    let maxReactionValueCount: number = 0;

    artworkReactionsSummary.forEach((item) => {
      if (item.counter > maxReactionValueCount) {
        maxReactionValues = [item.reactionValue];
        maxReactionValueCount = item.counter;
      } else if (item.counter > 0 && item.counter == maxReactionValueCount) {
        maxReactionValues.push(item.reactionValue);
      }
    });

    return maxReactionValues.findIndex((val) => val == reactionValue) >= 0 ? true : false;
  };

  return (
    <>
      <div className="flex flex-row justify-center items-start gap-20">
        {hostSummaryReactions.map((reaction, index) => {
          return (
            <motion.div
              key={`reaction-summary-${index}`}
              className={'flex flex-row items-center max-w-3xl'}
              initial={{ opacity: 0, y: -50, rotate: 90 }}
              animate={{ opacity: 1, y: 0, rotate: 0 }}
              transition={{ delay: 0.1 * index, type: 'spring', stiffness: 100 }}
            >
              <img src={reaction.src} className="h-64 w-64 mr-8" />
              <span className={`${isMostShared(reaction.reactionValue) ? 'text-[#cf165d]' : ''}`}>
                <motion.p
                  className="text-3xl font-bold"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{
                    delay: 0.1 * index + hostSummaryReactions.length * 0.1 - 0.1,
                    type: 'spring',
                    stiffness: 100
                  }}
                >
                  {artworkReactionsSummary.find(
                    (item) => item.reactionValue === reaction.reactionValue
                  )?.counter ?? 0}
                </motion.p>
              </span>
            </motion.div>
          );
        })}
      </div>
    </>
  );
};

export default ArtworkReactionsSummary;
